import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';
import { PostResponseBody } from '../types/api-response';
import { AxiosError } from 'axios';
import { ChecklistCategory } from '../types/checklist';

export type CreateChecklistCategoriesRequest = { categories: { name: string; reference: string }[] };

async function createChecklistCategories(
    checklistId: string,
    req: CreateChecklistCategoriesRequest
): Promise<PostResponseBody<ChecklistCategory>> {
    const { data } = await api.post(`/checklists/${checklistId}/categories`, req);
    return data;
}

export function useCreateChecklistCategories(
    checklistId: string
): UseMutationResult<PostResponseBody<ChecklistCategory>, AxiosError, CreateChecklistCategoriesRequest, unknown> {
    return useMutation((req) => createChecklistCategories(checklistId, req), {
        onSuccess: () => {
            queryClient.invalidateQueries(['checklists']);
        },
    });
}
